import { render, staticRenderFns } from "./AppDictionaryTab.vue?vue&type=template&id=7dac74fa"
import script from "./AppDictionaryTab.vue?vue&type=script&lang=js"
export * from "./AppDictionaryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports